module.exports = __webpack_public_path__ + "static/media/slideBg2.08d8d59e.jpg";